import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LabelItem, Tooltip } from '@twnel/web-components';

export const TransitionIcon = (props) => {
  const {
    entrypoint,
    getTexts,
    transitionKey,
    transitionStep,
  } = props;

  const iconConfig = {
    tooltipContent: 'End',
    icon: 'fas fa-check',
  };
  if (transitionStep.next) {
    if (transitionKey === entrypoint) {
      iconConfig.tooltipContent = 'Start';
      iconConfig.icon = 'fas fa-play';
    } else {
      iconConfig.tooltipContent = 'Step';
      iconConfig.icon = 'fas fa-angle-double-right';
    }
  }
  return (
    <Tooltip tooltip={{ content: getTexts(iconConfig.tooltipContent), position: 'left' }}>
      <i className={iconConfig.icon} />
    </Tooltip>
  );
};

TransitionIcon.defaultProps = {
  getTexts: (val) => val,
};

TransitionIcon.propTypes = {
  entrypoint: PropTypes.string.isRequired,
  getTexts: PropTypes.func,
  transitionKey: PropTypes.string.isRequired,
  transitionStep: PropTypes.shape({
    transition: PropTypes.string,
    next: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  }).isRequired,
};

export const CapitalizedText = styled.span`
  text-transform: capitalize;
  ${({ bold }) => (bold ? 'font-weight: 600;' : '')}
`;

CapitalizedText.defaultProps = {
  bold: false,
};

CapitalizedText.propTypes = {
  bold: PropTypes.bool,
};

export const BlockDivider = styled.hr`
  width: 80%;
  border: none;
  height: 1px;
  background-color: #FCFCFC;
  margin: 20px auto;
  filter: contrast(90%);
`;

export const StyledLabelItem = styled(LabelItem)`
  font-weight: 700;
  font-size: 0.8rem;
  ${({ noMargin }) => (noMargin ? 'margin: 0;' : '')}
`;
